(() => {
  if (window.MechanicalTrustSections?.initialize) {
    window.MechanicalTrustSections.initialize();
    return;
  }

  const revealSelector = '[data-mt-reveal]';

  const show = (element) => {
    element.classList.add('is-visible');
  };

  const initialize = (root = document) => {
    const elements = root.matches?.(revealSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(revealSelector) || []);

    if (!elements.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach(show);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          show(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08 }
    );

    elements.forEach((element) => {
      if (element.dataset.mtRevealBound === 'true') return;
      element.dataset.mtRevealBound = 'true';
      observer.observe(element);
    });
  };

  window.MechanicalTrustSections = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
